// removed by extract-text-webpack-plugin
module.exports = {"theme":"#00C0EF"};


//////////////////
// WEBPACK FOOTER
// ./src/styles/element-variables.scss
// module id = +hAf
// module chunks = 38